export default __webpack_public_path__ + "static/mcv-guide-banner-5e07a7a26fcd79b9559162af13d0882b.png";